import React from 'react'
import { IS_BROWSER } from '../../utils/constants'
import { IComplianceProps } from './CookieComplianceWrapper.types'

// MUI
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import { UseConsentState, useConsent } from '../../hooks/useConsent'

const CookieComplianceWrapper = ({ cookieConsent, children }: IComplianceProps) => {
  const consent = useConsent()
  const isArray = Array.isArray(cookieConsent)
  const { cookieFetched } = consent

  const consentCategories = new Map()

  consentCategories.set('Functional', ['cookie_cat_functional', 'Funktionelle'])
  consentCategories.set('Marketing', ['cookie_cat_marketing', 'Markedsføring'])
  consentCategories.set('Statistic', ['cookie_cat_statistic', 'Statistik'])

  const handleRenewConsent = () => {
    IS_BROWSER && window?.CookieConsent?.renew()
  }
  if (!cookieFetched) {
    return null
  }
  let categories = ''
  isArray &&
    cookieConsent.map(consentItem => {
      !consent[consentCategories.get(consentItem)[0] as keyof UseConsentState]
        ? categories !== ''
          ? (categories = categories + ` og ${consentCategories.get(consentItem)[1].toLowerCase()}`)
          : (categories = `${consentCategories.get(consentItem)[1].toLowerCase()}`)
        : ''
    })
  return IS_BROWSER && !isArray ? (
    <>
      {consent[consentCategories.get(cookieConsent)[0] as keyof UseConsentState] ? (
        children
      ) : (
        <Alert onClick={handleRenewConsent} style={{ cursor: 'pointer' }} severity="warning">
          <AlertTitle>Cookie Samtykke</AlertTitle>
          {`For at se dette indhold er du nødt til at give samtykke til ${consentCategories
            .get(cookieConsent)[1]
            .toLowerCase()} `}
          <br />
          <strong>
            <u>Klik her for at ændre dit samtykke</u>
          </strong>
        </Alert>
      )}
    </>
  ) : isArray ? (
    <>
      {categories === '' ? (
        children
      ) : (
        <Alert onClick={handleRenewConsent} style={{ cursor: 'pointer' }} severity="warning">
          <AlertTitle>Cookie Samtykke</AlertTitle>
          {`For at se dette indhold er du nødt til at give samtykke til ${categories} cookies`}
          <br />
          <strong>
            <u>Klik her for at ændre dit samtykke</u>
          </strong>
        </Alert>
      )}
    </>
  ) : (
    <></>
  )
}

export default CookieComplianceWrapper
